import * as React from "react";
const SvgFiRrEggFried = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-egg-fried_svg__a)">
      <path
        fill="#062147"
        d="M9.5 5c-7.268.231-7.267 10.77 0 11 7.268-.231 7.267-10.77 0-11m0 9a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m10.024-8.678a2.3 2.3 0 0 1-1.212-.866A9.94 9.94 0 0 0 9.549.01 10.227 10.227 0 0 0 0 11a13.015 13.015 0 0 0 13 13 8.22 8.22 0 0 0 7.829-6.121 2.54 2.54 0 0 1 .829-1.389c3.903-3.053 2.629-9.775-2.134-11.168m.854 9.631a4.55 4.55 0 0 0-1.5 2.487A6.16 6.16 0 0 1 13 22 11.013 11.013 0 0 1 2 11c-.339-4.727 3.367-9.047 8-9a7.94 7.94 0 0 1 6.646 3.566A4.26 4.26 0 0 0 18.9 7.223a4.523 4.523 0 0 1 1.478 7.73M13 19a1 1 0 1 1-1.999 0A1 1 0 0 1 13 19m7-8a1 1 0 1 1-1.999 0A1 1 0 0 1 20 11m-4 6a1 1 0 1 1-1.999 0A1 1 0 0 1 16 17"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-egg-fried_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEggFried;
